import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'

const getDefaultStateForCurrencies = () => {
  return {
    currencies: [],
    prefix:null
  }
}

// state
const state = getDefaultStateForCurrencies()

// getters
const getters = {

}

// mutations
const mutations = {
    FETCH_ALL(state, data){
        state.currencies = data
    },
    SET_PREFIX(state, data){
      if(data)
      {
        state.prefix = data.currency_prefix
      }
      else
      {
        state.prefix = null
      }
    },
    RESET_STATE_FOR_CURRENCIES (state) {
      Object.assign(state, getDefaultStateForCurrencies())
    },
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_CURRENCIES")
    },
    fetchAll({ commit }, data) {
        return axios.post(apiRoutes['CURRENCIES_LIST'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_ALL', response.data.data)
              } else {
                commit('FETCH_ALL', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    getPrefix({ commit }, data) {
      return axios.post(apiRoutes['GET_CURRENCY_PREFIX'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('SET_PREFIX', response.data.data)
            } else {
              commit('SET_PREFIX', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
}

export {
    state,
    getters,
    actions,
    mutations
}
